<template>
  <div class="parent">
    <div class="div1" style="display: flex;justify-content: flex-end;">
      <CustomSelectField style="margin-bottom:1px;margin-top:auto;width: 85px" :content=paginationInputs.pages />
    </div>
    <div class="div2" style="display: flex; justify-content: center">
      <button @click="changeIndex(-1)" :class="[{'read-only': index <= 0}]" class="button-icon"><span class="fas fa-chevron-left"></span></button>
      <div style="width: 10px"></div>
      <button class="button-icon" style="cursor: auto">{{index}}</button>
      <div style="width: 10px"></div>
      <button @click="changeIndex(1)" class="button-icon"><span class="fas fa-chevron-right"></span></button>
    </div>
    <div class="div3"></div>
  </div>
</template>

<script>
  import { library } from '@fortawesome/fontawesome-svg-core'
  import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
  import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
  import {CustomTableService} from "@/services/CustomTableService";
  library.add(faChevronLeft, faChevronRight);

  export default {
    name: 'PaginationArray',
    components: { CustomSelectField } ,
    props: ['defaultIndex', 'defaultPages', 'pagesReadOnly'],
    inject: ["tableId"],
    data: function() {
      return {
        index: this.defaultIndex ? this.defaultIndex : 0,
        paginationInputs: {
          pages: {value: Number(this.defaultPages) ? Number(this.defaultPages) : 25, type: 'select', selectValues: [
              {label:"5", value: 5},
              {label:"10", value: 10},
              {label:"25", value: 25},
              {label:"50", value: 50},
              {label:"100", value: 100},
              {label:"500", value: 500},
              {label:"1000", value: 1000}
            ], readOnly: this.pagesReadOnly ? this.pagesReadOnly : false},
        },
        isNextReloadCancel: false
      }
    },
    mounted() {
      this.initWithURLParams();
    },
    watch: {
      "paginationInputs.pages.value"() {
        if(!this.isNextReloadCancel){
          CustomTableService.data.get(this.tableId).loadData();
        }
        this.isNextReloadCancel = false;
      }
    },
    methods: {
      setPages(pages){
        if(this.paginationInputs.pages.value !== pages){
          this.isNextReloadCancel = true;
        }
        this.paginationInputs.pages.value = pages;
      },
      changeIndex(index){
        if(this.index + index >= 0) {
          this.index += index
          CustomTableService.data.get(this.tableId).loadData();
        }
      },
      /**
       * Init component data with those given in URL
       */
      initWithURLParams(){
        const query = this.$route.query;
        if(query.pages){ this.setPages(Number(query.pages)) }
        if(query.index){ this.index = Number(query.index) }
      },
      /**
       * Init component data with those given in params
       */
      init(index, pages){
        if(pages !== undefined){ this.setPages(pages) }
        if(index !== undefined){ this.index = Number(index) }
      },
      /**
       * Build component data for URL format
       * @returns {string}
       */
      urlParamsBuilder(){
        if(this.paginationInputs.pages.value !== undefined && this.index !== undefined) {
          return `pages=${this.paginationInputs.pages.value}&index=${this.index}&`;
        }else {
          return '';
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  //@media only screen and (min-width: DESKTOP_SIZE)
  //@media only screen and (min-width: TABLET_SIZE)

  .parent
    display grid
    grid-template-columns repeat(5, 1fr)
    grid-template-rows 1fr
    grid-column-gap 0
    grid-row-gap 0
    padding 12px 16px 14px
    border-top 1px solid PAGE_RULE_SOFT

  .div1 { grid-area: 1 / 5 / 2 / 6 }
  .div2 { grid-area: 1 / 2 / 2 / 5 }
  .div3 { grid-area: 1 / 1 / 2 / 2 }

  // Boutons précédent / page / suivant : contours fins, la page courante en citron
  .button-icon
    width 36px
    height 36px
    border 1px solid CTRL_BORDER
    border-radius CTRL_RADIUS_SM
    background-color white
    color THEME_COLOR_PRIMARY
    &:hover
      background-color CTRL_BG
      border-color CTRL_BORDER_HOVER
    &:active
      background-color CTRL_BG_HOVER

  .div2 .button-icon:nth-child(3)
    border-color FONT_COLOR
    background-color PAGE_LEMON
    color FONT_COLOR
    font-weight 700

  .read-only
    background-color CTRL_DISABLED_BG !important
    color CTRL_DISABLED_TEXT !important
    cursor auto !important
</style>
